import { IProducts } from "../../Utilities/Product";
import { GetQueryParameter } from "../../Utilities/Url";
import { Config } from "../../Utilities/Config";

export const Products: IProducts = {
  General: {
    workshopPdf: {
      english: "/pdfs/Product Training - Flyer without Prices - 2024-11 (ENG).pdf",
      german: "/pdfs/Produktschulung - Flyer ohne Preise - 2024-11 (DEU).pdf",
    },
    trustCenter:
      "https://trustcenter.solutions2share.com/documentation/trust-center",
  },
  Products: {
    TeamsManager: {
      information: {
        title: "Teams Manager",
        icon: "/img/Products/Tm/icon.png",
        logo: "/img/Products/Tm/logo.png",
      },
      categoryLinks: {
        knowledgeBase:
          "https://support.solutions2share.net/portal/en/kb/teams-manager",
        legacyDocumentation:
          "https://s2shelp.azurewebsites.net/documentation/Teams_Manager/IntroductiontoTeamsManager.html",
        // documentation:
        //   "https://kb-teamsmanager-solutions2share.portal.trainn.co/",
        roadmap: "https://app.loopedin.io/teams-manager/roadmap",
        ideas: "https://app.loopedin.io/teams-manager/ideas",
        updates: "https://app.loopedin.io/teams-manager/updates",
        showVideoTrainings: true,
        showWorkshop: true,
        apiDocs: Config.getFullSwaggerApiUrl(GetQueryParameter("theme", "light")),
        showTrustCenter: true,
      },
      categoryLinksUser: {
        legacyDocumentation:
          "https://help.solutions2share.net/documentation/Teams_Manager/IntroductiontoTeamsManager.html",
        documentation:
          "https://kb-teamsmanager-solutions2share.portal.trainn.co/",
        showVideoTrainings: true,
      },
      getStarted: {
        header: {
          titleId: "TM.Product.Title",
          altTitle: "Get Started with Teams Manager",
          descriptionId: "TM.Product.Description",
          altDescription:
            "Teams Manager greatly expands your administrative capabilities and gives you the ability to implement and control Templates, Naming Conventions, Lifecycles, Policies, and Approvals, and many more to enhance your tenant's governance.",
          primaryButtonTextId: "TM.GetStarted.Header.Button1",
          primaryButtonText: "Schedule a Demo",
          secondaryButtonTextId: "TM.GetStarted.Header.Button2",
          secondaryButtonText: "Pricing",
          image: "/img/Products/Tm/header.png",
          german: {
            videoLink: "https://youtu.be/tScLD-5Mh-k",
            primaryButtonLink:
              "https://www.solutions2share.com/de/demo-buchen/",
            secondaryButtonLink:
              "https://www.solutions2share.com/de/teams-manager/#pricing",
          },
          english: {
            videoLink: "https://youtu.be/tScLD-5Mh-k",
            primaryButtonLink: "https://www.solutions2share.com/book-a-demo/",
            secondaryButtonLink:
              "https://www.solutions2share.com/teams-manager/#pricing",
          },
        },
        specifications: [
          {
            icon: "BriefcaseIcon",
            title: "TM.GetStarted.InformationBox.GovernanceCard.Header",
            text: "TM.GetStarted.InformationBox.GovernanceCard.Text",
            altTitle: "Governance",
            altText:
              "Keep control of your Microsoft Teams infrastructure and prevent uncontrolled growth.",
          },

          {
            icon: "EyeIcon",
            title: "TM.GetStarted.InformationBox.OverviewCard.Header",
            text: "TM.GetStarted.InformationBox.OverviewCard.Text",
            altTitle: "Better overview",
            altText:
              "Use Lifecycle Management to get rid of inactive Teams, and Naming Conventions for a better overview in the MS Teams list.",
          },

          {
            icon: "MoleculeIcon",
            title: "TM.GetStarted.InformationBox.StructureCard.Header",
            text: "TM.GetStarted.InformationBox.StructureCard.Text",
            altTitle: "Structure",
            altText:
              "Provide your users with preconfigured templates and improve collaboration throughout MS Teams.",
          },

          {
            icon: "SurveyIcon",
            title: "TM.GetStarted.InformationBox.ApprovalWorkflowCard.Header",
            text: "TM.GetStarted.InformationBox.ApprovalWorkflowCard.Text",
            altTitle: "Approval workflow",
            altText:
              "Easily integrate an approval process with automatic workflows.",
          },

          {
            icon: "AppsIcon",
            title: "TM.GetStarted.InformationBox.AppStoreCard.Header",
            text: "TM.GetStarted.InformationBox.AppStoreCard.Text",
            altTitle: "Microsoft Teams AppStore",
            altText:
              "Get Teams Manager in the Teams AppStore and install it directly for a free tiral period.",
          },
        ],
        sections: [
          {
            navTitle: "TM.GetStarted.Sections.ApprovalWorkflow.MenuItem",
            title: "TM.GetStarted.Sections.ApprovalWorkflow.Header",
            text: "TM.GetStarted.Sections.ApprovalWorkflow.Description",
            img: "/img/Products/Tm/1.png",
            checkmarks: [
              "TM.GetStarted.Sections.ApprovalWorkflow.ListItem1",
              "TM.GetStarted.Sections.ApprovalWorkflow.ListItem2",
              "TM.GetStarted.Sections.ApprovalWorkflow.ListItem3",
            ],
            id: "0",
          },
          {
            navTitle: "TM.GetStarted.Sections.GovernancePolicies.MenuItem",
            title: "TM.GetStarted.Sections.GovernancePolicies.Header",
            text: "TM.GetStarted.Sections.GovernancePolicies.Description",
            img: "/img/Products/Tm/2.png",
            id: "1",
          },
          {
            navTitle: "TM.GetStarted.Sections.Provisioning.MenuItem",
            title: "TM.GetStarted.Sections.Provisioning.Header",
            text: "TM.GetStarted.Sections.Provisioning.Description",
            checkmarks: [
              "TM.GetStarted.Sections.Provisioning.ListItem1",
              "TM.GetStarted.Sections.Provisioning.ListItem2",
              "TM.GetStarted.Sections.Provisioning.ListItem3",
            ],
            img: "/img/Products/Tm/3.png",
            id: "2",
          },
          {
            navTitle: "TM.GetStarted.Sections.OnBoarding.MenuItem",
            title: "TM.GetStarted.Sections.OnBoarding.Header",
            text: "TM.GetStarted.Sections.OnBoarding.Description",
            checkmarks: [
              "TM.GetStarted.Sections.OnBoarding.ListItem1",
              "TM.GetStarted.Sections.OnBoarding.ListItem2",
              "TM.GetStarted.Sections.OnBoarding.ListItem3",
            ],
            img: "/img/Products/Tm/4.png",
            id: "3",
          },
        ],
        cardData: [
          {
            title:"TM.GetStarted.CardData.Card1.Title",
            description:"TM.GetStarted.CardData.Card1.Description",
            image:"/img/Products/Tm/TMCardIcon1.png",
            link:"https://intercom-help.eu/teams-manager/en/articles/288639-installing-teams-manager-to-m365"
          },
          {
            title:"TM.GetStarted.CardData.Card2.Title",
            description:"TM.GetStarted.CardData.Card2.Description",
            image:"/img/Products/Tm/TMCardIcon2.png",
            link:"https://intercom-help.eu/teams-manager/en/articles/288685-create-your-first-team-template-with-metadata"
          },
          {
            title:"TM.GetStarted.CardData.Card3.Title",
            description:"TM.GetStarted.CardData.Card3.Description",
            image:"/img/Products/Tm/TMCardIcon3.png",
            link:"https://intercom-help.eu/teams-manager/en/articles/288743-implement-naming-conventions"
          },
          {
            title:"TM.GetStarted.CardData.Card4.Title",
            description:"TM.GetStarted.CardData.Card4.Description",
            image:"/img/Products/Tm/TMCardIcon4.png",
            link:"https://intercom-help.eu/teams-manager/en/articles/300859-apply-lifecycles-and-auto-archival"
          },
          {
            title:"TM.GetStarted.CardData.Card5.Title",
            description:"TM.GetStarted.CardData.Card5.Description",
            image:"/img/Products/Tm/TMCardIcon5.png",
            link:"https://intercom-help.eu/teams-manager/en/articles/303554-execute-settings-via-policies"
          },
          {
            title:"TM.GetStarted.CardData.Card6.Title",
            description:"TM.GetStarted.CardData.Card6.Description",
            image:"/img/Products/Tm/TMCardIcon6.png",
            link:"https://intercom-help.eu/teams-manager/en/articles/303666-set-up-the-approval-process"
          },
          {
            title:"TM.GetStarted.CardData.Card7.Title",
            description:"TM.GetStarted.CardData.Card7.Description",
            image:"/img/Products/Tm/TMCardIcon7.png",
            link:"https://intercom-help.eu/teams-manager/en/articles/303703-control-access-with-access-reviews"
          }
        ]
      },
    },

    ExternalUserManager: {
      information: {
        title: "External User Manager",
        icon: "/img/Products/Eum/icon.png",
      },
      categoryLinks: {
        knowledgeBase:
          "https://support.solutions2share.net/portal/en/kb/external-user-manager",
        legacyDocumentation:
          "https://s2shelp.azurewebsites.net/documentation/External%20User%20Manager/IntroductiontoExternalUserManage.html",
        documentation: "https://solutions2share.portal.trainn.co/",
        roadmap: "https://app.loopedin.io/external-user-manager/roadmap",
        ideas: "https://app.loopedin.io/external-user-manager/ideas",
        updates: "https://app.loopedin.io/external-user-manager/updates",
        showVideoTrainings: false,
        showTrustCenter: true,
        apiDocs: "https://externalusermanager.azurefd.net/swagger/index.html",
      },
      categoryLinksUser: {
        legacyDocumentation:
        "https://s2shelp.azurewebsites.net/documentation/External%20User%20Manager/IntroductiontoExternalUserManage.html",
          //"https://help.solutions2share.net/documentation/External%20User%20Manager/IntroductiontoExternalUserManage.html",
        documentation: "https://solutions2share.portal.trainn.co/",
      },
      getStarted: {
        header: {
          titleId: "EUM.Product.Title",
          altTitle: "Manage Guest Users in Microsoft Teams",
          descriptionId: "EUM.Product.Description",
          altDescription: "Reporting, Monitoring and Access Management",
          primaryButtonTextId: "EUM.GetStarted.Header.Button1",
          primaryButtonText: "Schedule a Demo",
          secondaryButtonTextId: "EUM.GetStarted.Header.Button2",
          secondaryButtonText: "Pricing",
          image: "/img/Products/Eum/header.png",
          german: {
            videoLink: "https://youtu.be/F7OkAqLkUUI",
            primaryButtonLink:
              "https://www.solutions2share.com/de/demo-buchen/",
            secondaryButtonLink: "https://www.solutions2share.com/de/external-user-manager/#pricing"
          },
          english: {
            videoLink: "https://youtu.be/arGBrvoI6JE",
            primaryButtonLink:
              "https://www.solutions2share.com/book-a-demo/",
            secondaryButtonLink: "https://www.solutions2share.com/external-user-manager/#pricing"
          },
        },
        specifications: [
          {
            icon: "PersonIcon",
            title: "EUM.GetStarted.InformationBox.AW",
            text: "EUM.GetStarted.InformationBox.AW.Text",
            altTitle: "Approval workflow",
            altText:
              "Stay in control with the Integrate Approval Workflow and let users create a guest access request in one simple process.",
          },

          {
            icon: "LockIcon",
            title: "EUM.GetStarted.InformationBox.AC",
            text: "EUM.GetStarted.InformationBox.AC.Text",
            altTitle: "Access Control",
            altText:
              "Keep the overview with guest user permission overview and the guest user access history and create rules for NDA and GDPR.",
          },

          {
            icon: "MegaphoneIcon",
            title: "EUM.GetStarted.InformationBox.R",
            text: "EUM.GetStarted.InformationBox.R.Text",
            altTitle: "Reporting",
            altText:
              "Display active and interactive users, receive notifications about rule violations and stay in control of your enviroment.",
          },
        ],
        sections: [
          {
            navTitle: "EUM.GetStarted.Sections.GR",
            title: "EUM.GetStarted.Sections.GR.title",
            text: "EUM.GetStarted.Sections.GR.text",
            img: "/img/Products/Eum/1.png",
            id: "0",
          },
          {
            navTitle: "EUM.GetStarted.Sections.ARR",
            title: "EUM.GetStarted.Sections.ARR.title",
            text: "EUM.GetStarted.Sections.ARR.text",
            checkmarks: [
              "EUM.GetStarted.Sections.ARR.check1",
              "EUM.GetStarted.Sections.ARR.check2",
              "EUM.GetStarted.Sections.ARR.check3",
              "EUM.GetStarted.Sections.ARR.check4",
            ],
            img: "/img/Products/Eum/2.png",
            id: "1",
          },
          {
            navTitle: "EUM.GetStarted.Sections.SC",
            title: "EUM.GetStarted.Sections.SC.title",
            text: "EUM.GetStarted.Sections.SC.text",
            checkmarks: [
              "EUM.GetStarted.Sections.SC.check1",
              "EUM.GetStarted.Sections.SC.check2",
              "EUM.GetStarted.Sections.SC.check3",
              "EUM.GetStarted.Sections.SC.check4",
            ],
            img: "/img/Products/Eum/3.png",
            id: "2",
          },
        ],
        cardData: [
          {
            title:"EUM.GetStarted.CardData.Card1.Title",
            description:"EUM.GetStarted.CardData.Card1.Description",
            image:"/img/Products/Eum/EUMCardIcon1.png",
            link:"https://eum-helpcenter.solutions2share.com/en/articles/342093-introduction-to-external-user-manager"
          },
          {
            title:"EUM.GetStarted.CardData.Card2.Title",
            description:"EUM.GetStarted.CardData.Card2.Description",
            image:"/img/Products/Eum/EUMCardIcon2.png",
            link:"https://eum-helpcenter.solutions2share.com/en/articles/337193-install-external-user-manager-to-m365"
          },
          {
            title:"EUM.GetStarted.CardData.Card3.Title",
            description:"EUM.GetStarted.CardData.Card3.Description",
            image:"/img/Products/Eum/EUMCardIcon3.png",
            link:"https://eum-helpcenter.solutions2share.com/en/articles/337207-request-approval-flow"
          },
          {
            title:"EUM.GetStarted.CardData.Card4.Title",
            description:"EUM.GetStarted.CardData.Card4.Description",
            image:"/img/Products/Eum/EUMCardIcon4.png",
            link:"https://eum-helpcenter.solutions2share.com/en/articles/337426-create-metafields"
          },
          {
            title:"EUM.GetStarted.CardData.Card5.Title",
            description:"EUM.GetStarted.CardData.Card5.Description",
            image:"/img/Products/Eum/EUMCardIcon5.png",
            link:"https://eum-helpcenter.solutions2share.com/en/articles/337431-add-onboarding-media"
          },
          {
            title:"EUM.GetStarted.CardData.Card6.Title",
            description:"EUM.GetStarted.CardData.Card6.Description",
            image:"/img/Products/Eum/EUMCardIcon6.png",
            link:"https://eum-helpcenter.solutions2share.com/en/articles/337433-establish-an-onboarding-process"
          },
          {
            title:"EUM.GetStarted.CardData.Card7.Title",
            description:"EUM.GetStarted.CardData.Card7.Description",
            image:"/img/Products/Eum/EUMCardIcon7.png",
            link:"https://eum-helpcenter.solutions2share.com/en/articles/337435-implementing-naming-conventions"
          },
          {
            title:"EUM.GetStarted.CardData.Card8.Title",
            description:"EUM.GetStarted.CardData.Card8.Description",
            image:"/img/Products/Eum/EUMCardIcon8.png",
            link:"https://eum-helpcenter.solutions2share.com/en/articles/337468-control-access-with-access-reviews"
          },
          {
            title:"EUM.GetStarted.CardData.Card9.Title",
            description:"EUM.GetStarted.CardData.Card9.Description",
            image:"/img/Products/Eum/EUMCardIcon9.png",
            link:"https://eum-helpcenter.solutions2share.com/en/articles/337471-import-existing-guests"
          },
          {
            title:"EUM.GetStarted.CardData.Card10.Title",
            description:"EUM.GetStarted.CardData.Card10.Description",
            image:"/img/Products/Eum/EUMCardIcon10.png",
            link:"https://eum-helpcenter.solutions2share.com/en/articles/337473-insights-and-analytics"
          }
        ],
      },
    },

    HyperLinks: {
      information: {
        title: "Hyperlinks",
        icon: "/img/Products/Hl/icon.png",
      },
      categoryLinks: {
        legacyDocumentation:
          "https://help.solutions2share.net/documentation/Hyperlinks/Home.html",
        documentation: "https://solutions2share.portal.trainn.co/",
        ideas: "https://app.loopedin.io/teams-hyperlink/ideas",
        updates: "https://app.loopedin.io/teams-hyperlink/updates",
        showVideoTrainings: false,
        showTrustCenter: true,
      },
      categoryLinksUser: {
        legacyDocumentation:
          "https://help.solutions2share.net/documentation/Hyperlinks/Home.html",
        documentation: "https://solutions2share.portal.trainn.co/",
      },
      getStarted: {
        header: {
          titleId: "Hl.Product.Title",
          altTitle: "Microsoft Teams Bookmarks",
          descriptionId: "Hl.Product.Description",
          altDescription:
            "Save Links to Websites, Files, Conversations as Microsoft Teams Bookmarks",
          primaryButtonTextId: "Common.GetItNow",
          primaryButtonText: "Schedule a Demo",
          image: "/img/Products/Hl/header.png",
          german: {
            videoLink: "https://youtu.be/_dzVyGsdhcY",
            primaryButtonLink:
              "https://www.solutions2share.com/de/early-adopter-programm/",
          },
          english: {
            videoLink: "https://youtu.be/_dzVyGsdhcY",
            primaryButtonLink:
              "https://www.solutions2share.com/solutions2share-early-adopter-program/",
          },
        },
        specifications: [
          {
            icon: "CheckmarkCircleIcon",
            title: "Hl.GetStarted.InformationBox.SM",
            text: "Hl.GetStarted.InformationBox.SM.Text",
            altTitle: "Governance",
            altText:
              "Keep control of your Microsoft Teams infrastructure and prevent uncontrolled growth.",
          },

          {
            icon: "LinkIcon",
            title: "Hl.GetStarted.InformationBox.CL",
            text: "Hl.GetStarted.InformationBox.CL.Text",
            altTitle: "Better overview",
            altText:
              "Use Lifecycle Management to get rid of inactive Teams, and Naming Conventions for a better overview in the MS Teams list.",
          },

          {
            icon: "UserFriendsIcon",
            title: "Hl.GetStarted.InformationBox.SU",
            text: "Hl.GetStarted.InformationBox.SU.Text",
            altTitle: "Structure",
            altText:
              "Provide your users with preconfigured templates and improve collaboration throughout MS Teams.",
          },
        ],
        sections: [
          {
            navTitle: "Hl.GetStarted.Sections.O",
            title: "Hl.GetStarted.Sections.O.title",
            text: "Hl.GetStarted.Sections.O.text",
            img: "/img/Products/Hl/1.png",
            id: "0",
          },
          {
            navTitle: "Hl.GetStarted.Sections.A",
            title: "Hl.GetStarted.Sections.A.title",
            text: "Hl.GetStarted.Sections.A.text",
            img: "/img/Products/Hl/2.png",
            id: "1",
          },
          {
            navTitle: "Hl.GetStarted.Sections.ATC",
            title: "Hl.GetStarted.Sections.ATC.title",
            text: "Hl.GetStarted.Sections.ATC.text",
            img: "/img/Products/Hl/3.png",
            id: "2",
          },
        ],
      },
    },

    MindMap: {
      information: {
        title: "MindMap",
        icon: "/img/Products/Mm/icon.png",
      },
      categoryLinks: {
        legacyDocumentation:
          "https://help.solutions2share.net/documentation/MindMap/InstallationofMindMap.html",
        documentation: "https://solutions2share.portal.trainn.co/",
        ideas: "https://app.loopedin.io/teams-mindmap/ideas",
        updates: "https://app.loopedin.io/teams-mindmap/updates",
        showVideoTrainings: false,
        showTrustCenter: true,
      },
      categoryLinksUser: {
        legacyDocumentation:
          "https://help.solutions2share.net/documentation/MindMap/InstallationofMindMap.html",
        documentation: "https://solutions2share.portal.trainn.co/",
      },
      getStarted: {
        header: {
          titleId: "MM.Product.Title",
          altTitle: "Mindmap Your Ideas in Microsoft Teams",
          descriptionId: "MM.Product.Description",
          altDescription:
            "Create Mindmaps in Microsoft Teams with MindMap - the Powerful and Fully Integrated Mindmap Tool",
          primaryButtonTextId: "Common.GetItNow",
          primaryButtonText: "Schedule a Demo",
          image: "/img/Products/Mm/header.png",
          logoText: "Mindmap",
          german: {
            videoLink: "https://youtu.be/o8OWffkgVHU",
            primaryButtonLink:
              "https://www.solutions2share.com/de/early-adopter-programm/",
          },
          english: {
            videoLink: "https://youtu.be/o8OWffkgVHU",
            primaryButtonLink:
              "https://www.solutions2share.com/solutions2share-early-adopter-program/",
          },
        },
        specifications: [
          {
            icon: "BriefcaseIcon",
            title: "MM.GetStarted.InformationBox.SaveMoneyCard.Header",
            text: "MM.GetStarted.InformationBox.SaveMoneyCard.Text",
            altTitle: "Governance",
            altText:
              "Keep control of your Microsoft Teams infrastructure and prevent uncontrolled growth.",
          },

          {
            icon: "ChatIcon",
            title: "MM.GetStarted.InformationBox.CollectIdeas.Header",
            text: "MM.GetStarted.InformationBox.CollectIdeas.Text",
            altTitle: "Better overview",
            altText:
              "Use Lifecycle Management to get rid of inactive Teams, and Naming Conventions for a better overview in the MS Teams list.",
          },

          {
            icon: "UserFriendsIcon",
            title: "MM.GetStarted.InformationBox.CollaborationCard.Header",
            text: "MM.GetStarted.InformationBox.CollaborationCard.Text",
            altTitle: "Structure",
            altText:
              "Provide your users with preconfigured templates and improve collaboration throughout MS Teams.",
          },
        ],
        sections: [
          {
            navTitle:
              "MM.GetStarted.Sections.AddNotesOrTopologyDiagram.MenuItem",
            title: "MM.GetStarted.Sections.AddNotesOrTopologyDiagram.Header",
            text: "MM.GetStarted.Sections.AddNotesOrTopologyDiagram.Description",
            img: "/img/Products/Mm/header.png",
            id: "0",
          },
          {
            navTitle: "MM.GetStarted.Sections.SetReferences.MenuItem",
            title: "MM.GetStarted.Sections.SetReferences.Header",
            text: "MM.GetStarted.Sections.SetReferences.Description",
            img: "/img/Products/Mm/2.png",
            id: "1",
          },
          {
            navTitle: "MM.GetStarted.Sections.AddToTeamsChannel.MenuItem",
            title: "MM.GetStarted.Sections.AddToTeamsChannel.Header",
            text: "MM.GetStarted.Sections.AddToTeamsChannel.Description",
            img: "/img/Products/Mm/3.png",
            id: "2",
          },
        ],
      },
    },

    FileManager: {
      information: {
        title: "File Manager",
        icon: "/img/Products/Fm/icon.png",
      },
      categoryLinks: {
        roadmap: "https://app.loopedin.io/file-manager/roadmap",
        ideas: "https://app.loopedin.io/file-manager/ideas",
        updates: "https://app.loopedin.io/file-manager/updates",
        documentation: "https://solutions2share.portal.trainn.co/",
        showVideoTrainings: false,
        showTrustCenter: true,
      },
      categoryLinksUser: {
        documentation: "https://solutions2share.portal.trainn.co/",
      },
      getStarted: {
        header: {
          titleId: "FM.Product.Title",
          altTitle: "Microsoft Teams Document Management",
          descriptionId: "FM.Product.Description",
          altDescription:
            "File Explorer and DMS with File Manager for Microsoft Teams",
          primaryButtonTextId: "Common.BecomeEarlyAdopter",
          primaryButtonText: "Schedule a Demo",
          image: "/img/Products/Fm/header.png",
          german: {
            videoLink: "https://youtu.be/btbT7kRcL9M",
            primaryButtonLink:
              "https://www.solutions2share.com/de/early-adopter-programm/",
          },
          english: {
            videoLink: "https://youtu.be/MhdqCd2njj0",
            primaryButtonLink:
              "https://www.solutions2share.com/solutions2share-early-adopter-program/",
          },
        },
        specifications: [
          {
            icon: "PersonIcon",
            title: "FM.GetStarted.InformationBox.PFD",
            text: "FM.GetStarted.InformationBox.PFD.Text",
            altTitle: "Governance",
            altText:
              "Keep control of your Microsoft Teams infrastructure and prevent uncontrolled growth.",
          },

          {
            icon: "PaperclipIcon",
            title: "FM.GetStarted.InformationBox.OFS",
            text: "FM.GetStarted.InformationBox.OFS.Text",
            altTitle: "Better overview",
            altText:
              "Use Lifecycle Management to get rid of inactive Teams, and Naming Conventions for a better overview in the MS Teams list.",
          },

          {
            icon: "EyeIcon",
            title: "GetStarted.InformationBox.PMN",
            text: "GetStarted.InformationBox.PMN.Text",
            altTitle: "Structure",
            altText:
              "Provide your users with preconfigured templates and improve collaboration throughout MS Teams.",
          },
        ],
        sections: [
          {
            title: "FM.GetStarted.Sections.DMFMT.title",
            text: "FM.GetStarted.Sections.DMFMT.text",
            img: "/img/Products/Fm/1.png",
            id: "0",
          },
        ],
      },
    },

    Intranet: {
      information: {
        title: "Intranet",
        icon: "/img/Products/Intranet/icon.png",
      },
      categoryLinks: {
        knowledgeBase:
          "https://support.solutions2share.net/portal/en/kb/teams-manager",
        documentation: "https://solutions2share.portal.trainn.co/",
        roadmap:
          "https://app.loopedin.io/intranet-for-teams-by-solutions2share/roadmap",
        ideas:
          "https://app.loopedin.io/intranet-for-teams-by-solutions2share/ideas",
        updates:
          "https://app.loopedin.io/intranet-for-teams-by-solutions2share/updates",
        showVideoTrainings: false,
        showTrustCenter: true,
      },
      categoryLinksUser: {
        documentation: "https://solutions2share.portal.trainn.co/",
        knowledgeBase:
          "https://support.solutions2share.net/portal/en/kb/teams-manager",
      },
      getStarted: {
        header: {
          titleId: "Intranet.Product.Title",
          altTitle: "Your Multilingual Intranet in Microsoft Teams",
          descriptionId: "Intranet.Product.Description",
          altDescription:
            "Easy Multilingual Teams Intranet Integration and Modern User Experience",
          primaryButtonTextId: "Common.BookADemo",
          primaryButtonText: "Schedule a Demo",
          image: "/img/Products/Intranet/header.png",
          german: {
            primaryButtonLink:
              "https://www.solutions2share.com/de/early-adopter-programm/",
          },
          english: {
            primaryButtonLink:
              "https://www.solutions2share.com/solutions2share-early-adopter-program/",
          },
        },
        specifications: [
          {
            icon: "ScreenshareIcon",
            title: "Intranet.GetStarted.InformationBox.MMM",
            text: "Intranet.GetStarted.InformationBox.MMM.Text",
            altTitle: "Governance",
            altText:
              "Keep control of your Microsoft Teams infrastructure and prevent uncontrolled growth.",
          },

          {
            icon: "ContentViewGalleryIcon",
            title: "Intranet.GetStarted.InformationBox.TP",
            text: "Intranet.GetStarted.InformationBox.TP.Text",
            altTitle: "Better overview",
            altText:
              "Use Lifecycle Management to get rid of inactive Teams, and Naming Conventions for a better overview in the MS Teams list.",
          },

          {
            icon: "RobotIcon",
            title: "Intranet.GetStarted.InformationBox.BB",
            text: "Intranet.GetStarted.InformationBox.BB.Text",
            altTitle: "Structure",
            altText:
              "Provide your users with preconfigured templates and improve collaboration throughout MS Teams.",
          },
        ],
        sections: [
          {
            navTitle: "Intranet.GetStarted.Sections.Multilingual",
            title: "Intranet.GetStarted.Sections.Multilingual.title",
            text: "Intranet.GetStarted.Sections.Multilingual.text",
            img: "/img/Products/Intranet/1.png",
            id: "0",
          },
          {
            navTitle: "Intranet.GetStarted.Sections.Templates",
            title: "Intranet.GetStarted.Sections.Templates.title",
            text: "Intranet.GetStarted.Sections.Templates.text",
            img: "/img/Products/Intranet/2.png",
            id: "1",
          },
          {
            navTitle: "Intranet.GetStarted.Sections.CC",
            title: "Intranet.GetStarted.Sections.CC.title",
            text: "Intranet.GetStarted.Sections.CC.text",
            img: "/img/Products/Intranet/3.png",
            id: "2",
          },
        ],
      },
    },

    CollaborationManager: {
      information: {
        title: "Collaboration Manager",
        icon: "/img/Products/Cm/icon.png",
      },
      categoryLinks: {
        knowledgeBase:
          "https://support.solutions2share.net/portal/en/kb/teams-manager",
        documentation: "https://solutions2share.portal.trainn.co/",
        ideas: "https://app.loopedin.io/collaboration-manager-365/ideas",
        updates: "https://app.loopedin.io/collaboration-manager-365/updates",
        showVideoTrainings: false,
        showTrustCenter: true,
      },
      categoryLinksUser: {
        documentation: "https://solutions2share.portal.trainn.co/",
      },
      getStarted: {
        header: {
          titleId: "CM.Product.Title",
          altTitle: "SharePoint Site Templates",
          descriptionId: "CM.Product.Description",
          altDescription:
            "Provisioning for Sites, Groups and Teams with Approval Workflow",
          primaryButtonTextId: "Common.BookADemo",
          primaryButtonText: "Schedule a Demo",
          image: "/img/Products/Cm/header.png",
          german: {
            videoLink: "https://youtu.be/amYoqWwe378",
            primaryButtonLink:
              "https://www.solutions2share.com/de/demo-buchen/",
          },
          english: {
            videoLink: "https://youtu.be/N7qm62Wv5k8",
            primaryButtonLink: "https://www.solutions2share.com/book-a-demo/",
          },
        },
        specifications: [
          {
            icon: "CallPstnIcon",
            title: "CM.GetStarted.InformationBox.SS",
            text: "CM.GetStarted.InformationBox.SS.Text",
            altTitle: "Governance",
            altText:
              "Keep control of your Microsoft Teams infrastructure and prevent uncontrolled growth.",
          },

          {
            icon: "ContentViewGalleryIcon",
            title: "CM.GetStarted.InformationBox.T",
            text: "CM.GetStarted.InformationBox.T.Text",
            altTitle: "Better overview",
            altText:
              "Use Lifecycle Management to get rid of inactive Teams, and Naming Conventions for a better overview in the MS Teams list.",
          },

          {
            icon: "ScreenshareIcon",
            title: "CM.GetStarted.InformationBox.P",
            text: "CM.GetStarted.InformationBox.P.Text",
            altTitle: "Structure",
            altText:
              "Provide your users with preconfigured templates and improve collaboration throughout MS Teams.",
          },
        ],
        sections: [
          {
            navTitle: "CM.GetStarted.Sections.SelfService",
            title: "CM.GetStarted.Sections.SelfService.title",
            text: "CM.GetStarted.Sections.SelfService.text",
            img: "/img/Products/Cm/1.png",
            id: "0",
          },
          {
            navTitle: "CM.GetStarted.Sections.TemplateEngine",
            title: "CM.GetStarted.Sections.TemplateEngine.title",
            text: "CM.GetStarted.Sections.TemplateEngine.text",
            checkmarks: [
              "CM.GetStarted.Sections.TemplateEngine.checks.1",
              "CM.GetStarted.Sections.TemplateEngine.checks.2",
              "CM.GetStarted.Sections.TemplateEngine.checks.3",
              "CM.GetStarted.Sections.TemplateEngine.checks.4",
              "CM.GetStarted.Sections.TemplateEngine.checks.5",
            ],
            img: "/img/Products/Cm/2.png",
            id: "1",
          },
          {
            navTitle: "CM.GetStarted.Sections.Cockpit",
            title: "CM.GetStarted.Sections.Cockpit.title",
            text: "CM.GetStarted.Sections.Cockpit.text",
            img: "/img/Products/Cm/3.png",
            id: "2",
          },
          {
            navTitle: "CM.GetStarted.Sections.CollaborationManager",
            title: "CM.GetStarted.Sections.CollaborationManager.title",
            text: "CM.GetStarted.Sections.CollaborationManager.text",
            checkmarks: [
              "CM.GetStarted.Sections.CollaborationManager.checks.1",
              "CM.GetStarted.Sections.CollaborationManager.checks.2",
              "CM.GetStarted.Sections.CollaborationManager.checks.3",
              "CM.GetStarted.Sections.CollaborationManager.checks.4",
              "CM.GetStarted.Sections.CollaborationManager.checks.5",
            ],
            img: "/img/Products/Cm/4.png",
            id: "3",
          },
          {
            navTitle: "CM.GetStarted.Sections.Hybrid",
            title: "CM.GetStarted.Sections.Hybrid.title",
            text: "CM.GetStarted.Sections.Hybrid.text",
            img: "/img/Products/Cm/5.png",
            id: "4",
          },
        ],
      },
    },

    AppManager: {
      information: {
        title: "App Manager",
        icon: "/img/Products/Am/icon.png",
      },
      categoryLinks: {
        knowledgeBase:
          "https://support.solutions2share.net/portal/en/kb/teams-manager",
        documentation: "https://solutions2share.portal.trainn.co/",
        roadmap: "https://app.loopedin.io/app-manager/roadmap",
        ideas: "https://app.loopedin.io/app-manager/ideas",
        updates: "https://app.loopedin.io/app-manager/updates",
        showVideoTrainings: false,
        showTrustCenter: true,
      },
      categoryLinksUser: {
        documentation: "https://solutions2share.portal.trainn.co/",
        knowledgeBase:
          "https://support.solutions2share.net/portal/en/kb/teams-manager",
      },
      getStarted: {
        header: {
          titleId: "AM.Product.Title",
          altTitle: "Manage Microsoft Teams App Permissions",
          descriptionId: "AM.Product.Description",
          altDescription:
            "App Request, Lifecycle and Reporting of Microsoft Teams Apps and In-house AppStore",
          primaryButtonTextId: "Common.BecomeEarlyAdopter",
          primaryButtonText: "Become Early Adopter",
          image: "/img/Products/Am/header.png",
          logoText: "App Manager",
          german: {
            primaryButtonLink:
              "https://www.solutions2share.com/de/early-adopter-programm/",
          },
          english: {
            primaryButtonLink:
              "https://www.solutions2share.com/solutions2share-early-adopter-program/",
          },
        },
        specifications: [
          {
            icon: "AcceptIcon",
            title: "AM.GetStarted.InformationBox.ARR",
            text: "AM.GetStarted.InformationBox.ARR.Text",
            altTitle: "Governance",
            altText:
              "Keep control of your Microsoft Teams infrastructure and prevent uncontrolled growth.",
          },

          {
            icon: "ShieldKeyholeIcon",
            title: "AM.GetStarted.InformationBox.DS",
            text: "AM.GetStarted.InformationBox.DS.Text",
            altTitle: "Better overview",
            altText:
              "Use Lifecycle Management to get rid of inactive Teams, and Naming Conventions for a better overview in the MS Teams list.",
          },

          {
            icon: "CodeSnippetIcon",
            title: "AM.GetStarted.InformationBox.CAS",
            text: "AM.GetStarted.InformationBox.CAS.Text",
            altTitle: "Structure",
            altText:
              "Provide your users with preconfigured templates and improve collaboration throughout MS Teams.",
          },
        ],
        sections: [
          {
            navTitle: "AM.GetStarted.Sections.AR",
            title: "AM.GetStarted.Sections.AR.title",
            text: "AM.GetStarted.Sections.AR.text",
            img: "/img/Products/Am/1.png",
            checkmarks: [
              "AM.GetStarted.Sections.AR.check1",
              "AM.GetStarted.Sections.AR.check2",
              "AM.GetStarted.Sections.AR.check3",
              "AM.GetStarted.Sections.AR.check4",
            ],
            id: "0",
          },
          {
            navTitle: "AM.GetStarted.Sections.IAS",
            title: "AM.GetStarted.Sections.IAS.title",
            text: "AM.GetStarted.Sections.IAS.text",
            checkmarks: [
              "AM.GetStarted.Sections.IAS.check1",
              "AM.GetStarted.Sections.IAS.check2",
              "AM.GetStarted.Sections.IAS.check3",
              "AM.GetStarted.Sections.IAS.check4",
            ],
            img: "/img/Products/Am/2.png",
            id: "1",
          },
          {
            navTitle: "AM.GetStarted.Sections.LR",
            title: "AM.GetStarted.Sections.LR.title",
            text: "AM.GetStarted.Sections.LR.text",
            img: "/img/Products/Am/3.png",
            id: "2",
          },
          {
            navTitle: "AM.GetStarted.Sections.D",
            title: "AM.GetStarted.Sections.D.title",
            text: "AM.GetStarted.Sections.D.text",
            img: "/img/Products/Am/4.png",
            id: "3",
          },
        ],
      },
    },
  },
};
